import { vappContainer } from '@/application';
import { ActualDetailPageService } from '@pages/ActualDetailPage/services';

const MODULE_NAME = 'ActualDetailPage.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ActualDetailPageService>(
    ActualDetailPageService.displayName
  );
};

export const getPageContent = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'getPageContent';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.agent?.getFeatureActualDetail();
      if (content) {
        return resolve({
          key: 'RENDER_PAGE',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        return reject({
          key: 'RENDER_PAGE_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'RENDER_PAGE_ERROR',
        value: _msg,
      });
    }
  });
};
